import { extract, Node_Type } from '@wix/ricos';
import { getRichContentText } from './get-rich-content-text';
export const getImageCount = (content) => {
    return getNodeCount(content, Node_Type.IMAGE);
};
export const getGiphyCount = (content) => {
    return getNodeCount(content, Node_Type.GIF);
};
export const getVideoCount = (content) => {
    return getNodeCount(content, Node_Type.VIDEO);
};
export const getQuoteCount = (content) => {
    return getNodeCount(content, Node_Type.BLOCKQUOTE);
};
export const getCharacterCount = (content) => {
    return getRichContentText(content, '').length;
};
export const hasHtml = (content) => {
    return getNodeCount(content, Node_Type.HTML) > 0;
};
export const getGalleries = (content) => {
    const galleries = extract(content.nodes)
        .filter(({ type }) => type === Node_Type.GALLERY)
        .map(({ galleryData }) => ({
        layout: galleryData.options.layout.type,
        length: galleryData.items.length,
    }))
        .get();
    return galleries.length ? JSON.stringify(galleries) : null;
};
const getNodeCount = (content, nodeType) => {
    return extract(content.nodes)
        .filter(({ type }) => type === nodeType)
        .get().length;
};
//# sourceMappingURL=content-selectors.js.map